/*
 * Copyright (c) Funtip GbR 2018.
 * Simon Oldeboershuis, Perry Prust
 */

import * as React from 'react';
import { Route, Routes } from 'react-router';
import AlbumEdit from './AlbumEdit';
import AlbumList from './AlbumList';
import PlaylistMaintenance from './Maintenance';
import { PlaylistAdminFooter } from './PlaylistAdminFooter';
import MenuPlaylist from './PlaylistMenu';
import PlaylistSearch from './PlaylistSearch';
import PlaylistStatistics from './PlaylistStatistics';
import SongEdit from './SongEdit';
import SongList from './SongList';

interface PlaylistAdminAppProps {}

const PlaylistAdminApp: React.FC<PlaylistAdminAppProps> = (props) => {
    return (
        <>
            <MenuPlaylist {...props} />
            <div className="mx-3">
                <Routes>
                    <Route path={`song/:songId`} element={<SongEdit />} />
                    <Route path={`song`} element={<SongList />} />
                    <Route path={`statistics`} element={<PlaylistStatistics />} />
                    <Route path={`album/:albumId`} element={<AlbumEdit />} />
                    <Route path={`album`} element={<AlbumList />} />
                    <Route path={`search`} element={<PlaylistSearch />} />
                    <Route path={`maintenance`} element={<PlaylistMaintenance />} />
                </Routes>
                <PlaylistAdminFooter />
            </div>
        </>
    );
};

export const playlistAdminPath = () => '/playlist-admin';

export default PlaylistAdminApp;
